import { Play } from 'lucide-react';

/** Matches list-row avatar size (`h-6 w-6`) for Neo chat “open in Speak2Me”. */
export function Speak2MePlayControl({ onOpen }: { onOpen: () => void }) {
  return (
    <button
      type="button"
      className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-muted-foreground/45 bg-muted/80 text-muted-foreground transition-colors hover:border-muted-foreground/60 hover:bg-muted hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
      title="Open in Speak2Me"
      aria-label="Open in Speak2Me"
      onClick={(e) => {
        e.stopPropagation();
        onOpen();
      }}
    >
      <Play className="h-3 w-3 shrink-0" aria-hidden strokeWidth={2.25} />
    </button>
  );
}
